import baseExtremum from './_baseExtremum.js';
import baseLt from './_baseLt.js';
import identity from './identity.js';

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseLt)
    : undefined;
}

export default min;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/min.js
// module id = 711
// module chunks = 67